<template>
  <div class="admin-topbar shadow-sm">
    <div class="d-flex align-items-center">
      <button class="sidebar-toggle me-3" @click="$emit('toggle-sidebar')">
        <i class="bi bi-list"></i>
      </button>
    </div>

    <div class="d-flex align-items-center gap-4">
      <div class="notification-group d-flex align-items-center gap-3">
        <div class="notify-item" @click="goTo('/admin/wallet/approve')">
          <div class="notify-icon-wrapper text-teal">
            <i class="bi bi-cash-coin fs-4"></i>
            <span
              v-if="notifyStore.topupCount > 0"
              class="badge-count bg-warning"
            >
              {{ notifyStore.topupCount }}
            </span>
          </div>

          <div class="notify-popup shadow">
            <div class="popup-header bg-teal text-white">
              <h6 class="mb-0">คำขอเติมเงิน ({{ notifyStore.topupCount }})</h6>
            </div>
            <div class="popup-body">
              <div
                v-if="notifyStore.topupCount === 0"
                class="text-center p-3 text-muted"
              >
                <small>ไม่มีรายการรอตรวจสอบ</small>
              </div>
              <ul v-else class="list-unstyled mb-0">
                <li
                  v-for="item in notifyStore.latestTopups"
                  :key="item.id"
                  class="popup-item"
                >
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <div class="fw-bold text-dark" style="font-size: 0.9rem">
                        {{ item.username }}
                      </div>
                      <small class="text-muted">{{
                        formatDate(item.request_date)
                      }}</small>
                    </div>
                    <div class="text-success fw-bold">
                      +{{ formatCurrency(item.amount) }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div
              v-if="notifyStore.topupCount > 0"
              class="popup-footer text-center"
            >
              <small>คลิกเพื่อดูทั้งหมด</small>
            </div>
          </div>
        </div>

        <div class="notify-item" @click="goTo('/admin/wallet/withdraw')">
          <div class="notify-icon-wrapper text-danger">
            <i class="bi bi-bank fs-4"></i>
            <span
              v-if="notifyStore.withdrawalCount > 0"
              class="badge-count bg-danger"
            >
              {{ notifyStore.withdrawalCount }}
            </span>
          </div>

          <div class="notify-popup shadow">
            <div class="popup-header bg-danger text-white">
              <h6 class="mb-0">
                คำขอถอนเงิน ({{ notifyStore.withdrawalCount }})
              </h6>
            </div>
            <div class="popup-body">
              <div
                v-if="notifyStore.withdrawalCount === 0"
                class="text-center p-3 text-muted"
              >
                <small>ไม่มีรายการรออนุมัติ</small>
              </div>
              <ul v-else class="list-unstyled mb-0">
                <li
                  v-for="item in notifyStore.latestWithdrawals"
                  :key="item.id"
                  class="popup-item"
                >
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <div class="fw-bold text-dark" style="font-size: 0.9rem">
                        {{ item.username }}
                      </div>
                      <small
                        class="text-muted d-block"
                        style="font-size: 0.75rem"
                      >
                        {{ item.bank_name }}
                      </small>
                    </div>
                    <div class="text-danger fw-bold">
                      -{{ formatCurrency(item.amount) }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div
              v-if="notifyStore.withdrawalCount > 0"
              class="popup-footer text-center"
            >
              <small>คลิกเพื่อดำเนินการ</small>
            </div>
          </div>
        </div>
      </div>
      <div class="vr mx-2"></div>

      <div
        v-if="isDropdownOpen"
        @click="isDropdownOpen = false"
        style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          z-index: 999;
        "
      ></div>

      <div class="user-info dropdown" style="position: relative; z-index: 1000">
        <div
          class="d-flex align-items-center dropdown-toggle"
          role="button"
          @click="isDropdownOpen = !isDropdownOpen"
          style="cursor: pointer"
        >
          <span class="d-none d-md-inline text-muted small">ยินดีต้อนรับ,</span>
          <strong class="admin-name ms-1">{{
            auth.adminName || "Admin"
          }}</strong>
          <i class="bi bi-person-circle admin-icon"></i>
        </div>

        <ul
          class="dropdown-menu dropdown-menu-end shadow border-0 mt-2"
          :class="{ show: isDropdownOpen }"
          style="min-width: 200px; position: absolute; right: 0; top: 100%"
        >
          <li class="px-3 py-2 text-muted small bg-light border-bottom">
            <i class="bi bi-person-badge me-2"></i>
            <strong>{{ auth.adminName || "Admin" }}</strong>
          </li>
          <li>
            <a
              class="dropdown-item py-2 mt-1"
              href="#"
              @click.prevent="
                openPasswordModal();
                isDropdownOpen = false;
              "
            >
              <i class="bi bi-key-fill text-warning me-2"></i> เปลี่ยนรหัสผ่าน
            </a>
          </li>
          <li><hr class="dropdown-divider" /></li>
          <li>
            <a
              class="dropdown-item py-2 text-danger"
              href="#"
              @click.prevent="
                handleLogout();
                isDropdownOpen = false;
              "
            >
              <i class="bi bi-box-arrow-right me-2"></i> ออกจากระบบ
            </a>
          </li>
        </ul>
      </div>

      <AdminChangePasswordModal ref="pwdModal" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useAdminAuthStore } from "@/stores/adminAuthStore";
import { useNotificationStore } from "@/stores/notificationStore";
import AdminChangePasswordModal from "@/components/admin/AdminChangePasswordModal.vue";
import Swal from "sweetalert2";

const auth = useAdminAuthStore();
const notifyStore = useNotificationStore();
const router = useRouter();
let pollingInterval = null;

// ฟังก์ชันจัดรูปแบบเงิน
const formatCurrency = (val) =>
  new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(val);

// ฟังก์ชันจัดรูปแบบวันที่สั้นๆ
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return (
    date.toLocaleDateString("th-TH", { day: "2-digit", month: "2-digit" }) +
    " " +
    date.toLocaleTimeString("th-TH", { hour: "2-digit", minute: "2-digit" })
  );
};

const goTo = (path) => {
  router.push(path);
};

const pwdModal = ref(null);
const isDropdownOpen = ref(false); // 👈 เพิ่มบรรทัดนี้เข้ามาใหม่ครับ

const openPasswordModal = () => {
  if (pwdModal.value) {
    pwdModal.value.openModal(); // เรียกใช้ฟังก์ชันเปิดหน้าต่างที่อยู่ใน Modal
  }
};

const handleLogout = () => {
  Swal.fire({
    title: "ออกจากระบบ?",
    text: "คุณต้องการออกจากระบบ TGS Admin ใช่หรือไม่",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "ใช่, ออกจากระบบ",
    cancelButtonText: "ยกเลิก",
  }).then((result) => {
    if (result.isConfirmed) {
      auth.logout(); // เรียกใช้ฟังก์ชัน Logout จาก auth store ของคุณวิธ
      router.push("/admin/login"); // เด้งกลับไปหน้าล็อกอิน
    }
  });
};

onMounted(() => {
  // 1. ดึงข้อมูลทันทีเมื่อโหลดหน้า
  notifyStore.fetchNotifications();

  // 2. ตั้งเวลาดึงข้อมูลใหม่ทุกๆ 30 วินาที (Polling) เพื่อให้ตัวเลข Realtime
  pollingInterval = setInterval(() => {
    notifyStore.fetchNotifications();
  }, 30000);
});

onUnmounted(() => {
  if (pollingInterval) clearInterval(pollingInterval);
});
</script>

<style scoped>
/* Main Layout */
.admin-topbar {
  background-color: #ffffff;
  padding: 0 20px; /* ลด padding แนวตั้งเพราะกำหนด height แล้ว */
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* User Info Styles */
.user-info {
  display: flex;
  align-items: center;
  font-family: "Kanit", sans-serif;
  cursor: default;
}
.admin-name {
  color: #0d7579;
}
.admin-icon {
  font-size: 1.8rem;
  color: #6c757d;
  margin-left: 0.5rem;
}
.sidebar-toggle {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  display: none;
  color: #343a40;
}

/* === Notification Styles (หัวใจสำคัญ) === */
.notify-item {
  position: relative;
  cursor: pointer;
  padding: 8px;
}

.notify-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f8f9fa;
  transition: all 0.2s ease;
}

.notify-item:hover .notify-icon-wrapper {
  background-color: #e9ecef;
  transform: translateY(-2px);
}

.badge-count {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  font-size: 0.7rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid #fff;
  font-weight: bold;
}

/* === Popup Styles (CSS Hover Logic) === */
.notify-popup {
  position: absolute;
  top: 100%;
  right: -10px; /* ปรับให้ Popup เยื้องขวานิดหน่อย */
  width: 300px;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  margin-top: 10px;

  /* ซ่อนไว้ก่อน */
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.2s ease-in-out;
  z-index: 1100;
}

/* แสดง Popup เมื่อ Hover ที่ .notify-item */
.notify-item:hover .notify-popup {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* หัวลูกศรชี้ขึ้น (Optional) */
.notify-popup::before {
  content: "";
  position: absolute;
  top: -6px;
  right: 20px; /* ตรงกับตำแหน่ง icon */
  width: 12px;
  height: 12px;
  background: white;
  transform: rotate(45deg);
  border-left: 1px solid rgba(0, 0, 0, 0.05);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.popup-header {
  padding: 10px 15px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.popup-body {
  max-height: 300px;
  overflow-y: auto;
}

.popup-item {
  padding: 10px 15px;
  border-bottom: 1px solid #f1f1f1;
  transition: background 0.2s;
}

.popup-item:hover {
  background-color: #f8f9fa;
}

.popup-item:last-child {
  border-bottom: none;
}

.popup-footer {
  padding: 8px;
  background-color: #f8f9fa;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  color: #6c757d;
  font-size: 0.8rem;
  border-top: 1px solid #eee;
}

/* Colors */
.text-teal {
  color: #0d7579;
}
.bg-teal {
  background-color: #0d7579;
}

@media (max-width: 992px) {
  .sidebar-toggle {
    display: block;
  }
  .notify-popup {
    /* บนมือถืออาจจะปรับให้ popup เต็มจอหรือชิดขวามากขึ้น */
    right: -50px;
    width: 280px;
  }
}

/* ซ่อนลูกศรสามเหลี่ยมของ Dropdown (เพราะเรามีไอคอนคนอยู่แล้ว) */
.user-info .dropdown-toggle::after {
  display: none;
}
.user-info:hover .admin-icon {
  color: #0d7579; /* พอชี้เมาส์ที่ชื่อ ไอคอนคนจะเปลี่ยนเป็นสีเขียว TGS */
  transition: 0.3s ease;
}
</style>
